import React from 'react';
import { Section } from '@fiverr-private/fit';
import { Container } from '@fiverr-private/layout_components';

export const BannerWrapper: React.FC = ({ children }) => (
    <Section className="p-t-0 p-b-0">
        <Container marginTop={{ default: '6', md: '16' }} marginBottom={{ default: '6', md: '0' }}>
            {children}
        </Container>
    </Section>
);
